import React from 'react';

import { useDossierCustomHeader, useSearchBar } from '@europrocurement/l2d-modules';
import { GenericSearchBar } from '@europrocurement/l2d-modules/modules/Societes/components';
import { useParcoursFormalitreHeader } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { Box, Container } from '@mui/system';
import { Stepper } from '@europrocurement/flexy-components';
import { DossierDocumentsValidationCustomHeader } from '../pages/Dossiers/components';
import DossierDetailCustomHeader from '../pages/Dossiers/components/DossierDetailCustomHeader/DossierDetailCustomHeader';

const B2DCustomHeader: React.FunctionComponent = function () {
    const { isSearchBarPath } = useSearchBar();
    const { isParcoursPath, steps } = useParcoursFormalitreHeader();
    const { isDossierValidationPath, isDossierDetailPath } = useDossierCustomHeader();

    if (isSearchBarPath) {
        return <GenericSearchBar />;
    }

    if (isParcoursPath) {
        return (
            <Box sx={{ width: '100%', padding: 'auto' }}>
                <Container maxWidth="md">
                    <Stepper steps={steps} />
                </Container>
            </Box>
        );
    }

    if (isDossierValidationPath) {
        return <DossierDocumentsValidationCustomHeader />;
    }

    if (isDossierDetailPath) {
        return <DossierDetailCustomHeader />;
    }

    return null;
};

export default B2DCustomHeader;
